import { createFileRoute } from "@tanstack/react-router";
import { PortalPage } from "@/components/portal/PortalPage";
import { buildSeo } from "@/lib/seo";

export const Route = createFileRoute("/portal/favoritos")({
  head: () =>
    buildSeo({
      title: "Favoritos · Bizaclia",
      description: "Tus locales guardados como favoritos en Bizaclia.",
      path: "/portal/favoritos",
      noindex: true,
    }),
  component: () => <PortalPage segments={[]} mode="favoritos" />,
});
